import React from 'react';
import {TableBtnCol, TableData} from './table-sections/TableData.js';
import {TableHeader} from './table-sections/TableHeader.js';
import {TableRow} from './table-sections/TableRow.js';
import {SortableTableHeader} from './tableFeatures/SortableTableHeader.js';
import {TableBtn} from './tableFeatures/TableBtnCol.js';

import {isSafari} from '../../mixin/safari-mod.js';
import {StickyRowHeader} from './table-sections/StickyRowHeader.js';
import {TableSafari} from './TableSafari.js';
import {TableWrapper} from './TableWrapper.js';

export const Table = ({children, ...props}) => {
    if (isSafari) {
        return <TableSafari {...props}> {children} </TableSafari>;
    } else {
        return <TableWrapper {...props}>{children}</TableWrapper>;
    }
};

Table.Wrapper = TableWrapper;
Table.Row = TableRow;
Table.Header = TableHeader;
Table.StickyThead = StickyRowHeader;

Table.Data = TableData;
Table.BtnCol = TableBtnCol;

Table.Btn = TableBtn;
Table.HeaderSortable = SortableTableHeader;
